import { useCallback, useEffect, useRef, useState } from 'react';
import manager, { PRIORITY_LEVELS } from '@blofin/blofin-utils/priority/taskManager';

const usePriority = ({ priority = PRIORITY_LEVELS.LEVEL_DEFAULT }: { priority?: number }) => {
  const [havePriority, setHavePriority] = useState(false);
  const releaseRef = useRef<() => void>();

  useEffect(() => {
    if (!releaseRef.current) {
      releaseRef.current = manager.addTask({ priority: priority }, () => {
        setHavePriority(true);
      });
    }
  }, [releaseRef]);

  const release = useCallback(() => {
    if (releaseRef.current) {
      releaseRef.current();
      releaseRef.current = undefined;
    }
  }, [releaseRef]);

  return {
    granted: havePriority,
    release: release,
  };
};

export default usePriority;
